export default __webpack_public_path__ + "static/startpage-header-icon-e7e6f834d4f51cf9c1415bd2971f5bb1.png";